export default "__VITE_ASSET__Cey2FwDL__"